import { Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useContext } from 'react';

// Types.
import InstanceTarget from '../../types/instance/InstanceTarget';
import HostTarget from '../../types/host/HostTarget';
import EventType from '../../types/instance/EventType';

// Contexts.
import { FilterContext } from '../../context/FilterContext';

// Helpers.
import { getFilterParameters } from '../../helpers/utils';

// Constants.

// Views.
import List from './List';
import Detail from './Detail';
import Statement from '../Statement/Statement';
import GenericStatement from "../Statement/GenericStatement";
import SQLStatisticStatement from "../Statement/SQLStatisticStatement";
import NotFound from "../NotFound";

interface IInstancesProps {
    instances: InstanceTarget[],
    hosts: HostTarget[],
    eventTypes: EventType[],
    toggleMenu: Function,
    setFilterOptions: Function
}

const Instances = (props: IInstancesProps) => {
    const { instances, hosts, eventTypes, toggleMenu, setFilterOptions } = props;
    const { currentFilterOptions } = useContext(FilterContext);

    const filterParameters = getFilterParameters(currentFilterOptions);

        const paths = [
            "/:instanceId/activity/statement/:statementId/*",
            "/:instanceId/activity/groupedstatement/:statementId/*",
            "/:instanceId/activity/batch/:batchId/statement/:batchStatementId/*",
            "/:instanceId/activity/batch/:batchId/*",
            "/:instanceId/activity/groupedbatch/:batchId/groupedstatement/:batchStatementId/*",
            "/:instanceId/activity/groupedbatch/:batchId/*",
        ];

    return (
        <Routes>

            {paths.map((path) => (
                <Route
                    key={path}
                    path={path}
                    element={<Statement
                            instances={instances}
                            eventTypes={eventTypes}
                            toggleMenu={toggleMenu}
                           
                            setFilterOptions={setFilterOptions}
                        />
                    }
                />
            ))}

            <Route
                path="/:instanceId/sql-statistics/statement/:statementId/*"
                element={<SQLStatisticStatement
                    instances={instances}
                    hosts={hosts}
                    eventTypes={eventTypes}
                    toggleMenu={toggleMenu}
                   
                    setFilterOptions={setFilterOptions}
                />}
            />

            <Route
                path="/:instanceId/statement-activity/:statementId/*"
                element={<GenericStatement
                    instances={instances}
                    hosts={hosts}
                    eventTypes={eventTypes}
                    toggleMenu={toggleMenu}
                   
                    setFilterOptions={setFilterOptions}
                />}
            />

            {/* Instances List Route */}
            <Route path="/" element={<List
                toggleMenu={toggleMenu}
               
                filterParameters={filterParameters}
                setFilterOptions={setFilterOptions}
            />} />

            {/* Instance Detail */}
            <Route path="/:instanceId/*" element={<Detail instances={instances} hosts={hosts} eventTypes={eventTypes} toggleMenu={toggleMenu} setFilterOptions={setFilterOptions} />} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

Instances.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    setFilterOptions: PropTypes.func.isRequired
};

export default Instances;
